import { ToastService } from '@taxdown/piccolo-web';

export const AlertTypes = Object.freeze({
  success: Symbol('success'),
  info: Symbol('info'),
  warn: Symbol('warn'),
  error: Symbol('error'),
});

const notificationMap = {
  [AlertTypes.success]: ToastService.success,
  [AlertTypes.info]: ToastService.info,
  [AlertTypes.warn]: ToastService.warning,
  [AlertTypes.error]: ToastService.error,
};

const NotificationService = {
  sendNotification: (message: string, type: symbol, title?: string): void => {
    try {
      if (message) {
        const msg = message || message.toString();
        const notify = notificationMap[type] || ToastService.error;
        notify({ description: msg, title });
      }
    } catch (err: unknown) {
      if (err instanceof Error) {
        ToastService.error({ description: err.message });
      }
    }
  },
};

export default NotificationService;
